export default __webpack_public_path__ + "static/media/whiteAgentLogo.4e112a9b.svg";